import React from 'react';
import Dropdown from 'core/dropdown';
import noop from 'utils/noop';
import { formatCities, getCitiesByName, getCurrentValue } from './helpers';

// type Props = {
//   /** Additional Classes. */
//   className: string,
//   /** Currently selected city object. */
//   city: {},
//   /** If it is disabled. */
//   disabled?: boolean,
//   /** Latitude of selected city. */
//   lat: number,
//   /** Minimum number of characters to start search. */
//   lengthToSearch: number,
//   /** Longitude of selected city. */
//   lon: number,
//   /** Callback function when city is changed. */
//   onChange: () => {},
//   /** Placeholder text of dropdown. */
//   placeholder: string,
// };

export default class CityDropdown extends React.Component {
  static defaultProps = {
    city: {},
    lengthToSearch: 3,
    onChange: noop,
    placeholder: 'Search for a city...',
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchQuery: '',
      value: '',
    };
  }

  /**
   * getCurrentValue
   * Gets the current value of the dropdown if lat/lon value props match state when closed.
   * @returns { String } The current value of the dropdown.
   */
  getCurrentValue = () => getCurrentValue(this.state, this.props);

  /**
   * handleClose
   * Callback function when dropdown closes.
   * @returns { void }
   */
  handleClose = () => {
    const { currentLat, currentLon } = this.state;
    const { lat, lon } = this.props;
    if (currentLat !== undefined || currentLon !== undefined) {
      if (currentLat !== lat && currentLon !== lon) {
        this.props.onChange({}, { lat: currentLat, lon: currentLon });
      }
    }
    this.setState({ open: false, searchQuery: '', hasChanged: false });
  };

  /**
   * handleOpen
   * Callback function when dropdown open.
   * @returns { void }
   */
  handleOpen = () => {
    this.setState({ open: true });
  };

  /**
   * handleChange
   * Callback function when value changes.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: The updated props with new value.
   * @returns { void }
   */
  handleChange = (e, { value }) => {
    if (value) {
      const [lat, lon] = value.split(',');
      this.props.onChange(e, { lat, lon });
      this.setState({ currentLat: lat, currentLon: lon, value });
    } else {
      this.setState({ searchQuery: '', value: '', options: [] });
    }
  };

  /**
   * handleSearchChange
   * Callback function when searchQuery changes.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: The updated props with new searchQuery value.
   * @returns { void }
   */
  handleSearchChange = (e, { searchQuery }) => {
    if (/^([A-z ])*$/.test(searchQuery)) {
      if (searchQuery.length < this.props.lengthToSearch) {
        this.setState({ searchQuery, options: [] });
      } else {
        const options = formatCities(getCitiesByName(searchQuery));
        this.setState({ searchQuery, options });
      }
    }
  };

  render() {
    const { currentCity, currentLat, open, options, searchQuery } = this.state;
    const { city, className, lengthToSearch, placeholder, disabled } = this.props;
    const value = this.getCurrentValue();
    const hasCity = city && city.value;
    const cityPlaceholder =
      hasCity && !currentCity && currentLat === undefined ? city.value : placeholder;
    const noResultsMessage =
      searchQuery.length < lengthToSearch
        ? `Enter ${lengthToSearch} or more characters to search for a city...`
        : undefined;

    return (
      <Dropdown
        className={className}
        clearable
        disabled={disabled}
        fluid
        open={open}
        options={options}
        noResultsMessage={noResultsMessage}
        onChange={this.handleChange}
        onClose={this.handleClose}
        onOpen={this.handleOpen}
        onSearchChange={this.handleSearchChange}
        placeholder={cityPlaceholder}
        search
        searchQuery={searchQuery}
        value={value}
      />
    );
  }
}
